(function () {
  function getProductVariants() {
    const scripts = document.querySelectorAll('script:not([src])');
    for (const s of scripts) {
      const match = s.textContent.match(/const productVariants\s*=\s*(\[[\s\S]*?\]);/);
      if (match) {
        try { return JSON.parse(match[1]); } catch (e) {}
      }
    }
    return [];
  }

  function filterMediaByVariant(variantId) {
    const variants = getProductVariants();
    if (!variants.length) return;

    const variant = variants.find(v => v.id == variantId);
    if (!variant) return;

    const featuredMediaId = variant.featured_media ? String(variant.featured_media.id) : null;

    const mediaItems = document.querySelectorAll('.product-media-carousel__slide[data-media-id]');
    if (!mediaItems.length) return;

    if (!featuredMediaId) {
      mediaItems.forEach(item => {
        item.style.removeProperty('display');
        item.hidden = false;
      });
      return;
    }

    let anyVisible = false;
    mediaItems.forEach(item => {
      const mediaId = item.getAttribute('data-media-id');
      if (mediaId === featuredMediaId) {
        item.style.removeProperty('display');
        item.hidden = false;
        anyVisible = true;
      } else {
        item.style.setProperty('display', 'none', 'important');
        item.hidden = true;
      }
    });

    if (!anyVisible) {
      mediaItems.forEach(item => {
        item.style.removeProperty('display');
        item.hidden = false;
      });
    }
  }

  function getCurrentVariantId() {
    const input = document.querySelector('input[name="id"][type="hidden"]');
    return input ? input.value : null;
  }

  // Ejecutar con delays escalonados para asegurar que va DESPUÉS del tema y revy-bundle
  function filterWithDelay(variantId) {
    [50, 200, 500, 1000].forEach(delay => {
      setTimeout(() => filterMediaByVariant(variantId), delay);
    });
  }

  function observeVariantInput() {
    const input = document.querySelector('input[name="id"][type="hidden"]');
    if (!input) return;
    let lastValue = input.value;

    setInterval(() => {
      if (input.value !== lastValue) {
        lastValue = input.value;
        filterWithDelay(input.value);
      }
    }, 100);
  }

  document.addEventListener('change', function (e) {
    if (e.target?.closest('form[action*="/cart/add"]')) {
      setTimeout(() => {
        const id = getCurrentVariantId();
        if (id) filterWithDelay(id);
      }, 50);
    }
  });

  document.addEventListener('variant:changed', function (e) {
    const id = e.detail?.variant?.id || e.detail?.id;
    if (id) filterWithDelay(id);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const id = getCurrentVariantId();
    if (id) filterWithDelay(id);
    observeVariantInput();
  });
})();
